import { CUSTOMER_COMMISSION_PERCENTAGE } from '@swimmy_/helpers';

import { types as sdkTypes } from '../util/sdkLoader';

const { Money } = sdkTypes;

export const withCustomerFee = (money) => {
  if (!money) return null;

  const amountWithFee = (money.amount * (100 + CUSTOMER_COMMISSION_PERCENTAGE)) / 100;

  return new Money(amountWithFee, money.currency);
};

export const getCustomerCommissionPercentage = (guestCount = 0) => {
  return guestCount >= 10 ? 10 : CUSTOMER_COMMISSION_PERCENTAGE;
};

// minTotalAmountPerBooking is stored as major unit (e.g. "50" for 50 EUR)
// This returns the minimum customer pay-in total in cents.
export const getMinTotalAmountPerBookingWithCustomerFee = (
  minTotalAmountPerBooking,
  guestCount = 0
) => {
  const minTotalInt = parseInt(minTotalAmountPerBooking, 10);
  if (!Number.isFinite(minTotalInt) || minTotalInt <= 0) return 0;

  const baseCents = minTotalInt * 100;
  const customerPct = getCustomerCommissionPercentage(guestCount);
  return Math.round((baseCents * (100 + customerPct)) / 100);
};

// Converts a customer pay-in total (cents) back to base total (cents).
export const getBaseTotalFromCustomerTotal = (customerTotalCents, guestCount = 0) => {
  const customerPct = getCustomerCommissionPercentage(guestCount);
  return Math.round((customerTotalCents * 100) / (100 + customerPct));
};
